import { render } from "./pieChart3.vue?vue&type=template&id=05f9adc8"
import script from "./pieChart3.vue?vue&type=script&lang=js"
export * from "./pieChart3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__